import React from 'react';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';

// Styled toggle button with different colors based on state
const ToggleButton = styled(Button)(({ theme, isAnd, disabled }) => ({
  borderRadius: '6px',
  fontWeight: 'bold',
  border: isAnd ? '2px solid #a3a1ca' : '2px solid #458f80',
  backgroundColor: disabled 
    ? theme.palette.action.disabledBackground 
    : isAnd 
      ? '#bebcd6' 
      : '#add3cb',
  color: disabled ? theme.palette.text.disabled : 'black',
  '&:hover': {
    backgroundColor: disabled 
      ? theme.palette.action.disabledBackground 
      : isAnd 
        ? '#8e8cc4' 
        : '#43a08c',
  },
  cursor: disabled ? 'not-allowed' : 'pointer',
  transition: 'background-color 0.3s ease',
}));

const AndOrToggle = ({ value, onChange, index, defaultValue = "1", disabled = false }) => {
  const isAnd = value === "1";

  const handleToggle = () => {
    if (disabled) return;
    const newValue = isAnd ? "2" : "1";
    onChange({
      target: {
        value: newValue
      }
    });
  };

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
      <Tooltip 
        placement="right" 
        title={disabled 
          ? "Editing disabled" 
          : isAnd ? "Click to change to OR" : "Click to change to AND"} 
        arrow
      >
        <span> {/* Wrapping span for tooltip to work when disabled */}
          <ToggleButton
            variant="contained"
            isAnd={isAnd}
            onClick={handleToggle}
            disabled={disabled}
          >
            {isAnd ? 'AND' : 'OR'}
          </ToggleButton>
        </span>
      </Tooltip>
    </Box>
  );
};

export default AndOrToggle;